export const isPixiStandAlone = false;
import appConfig from "config/app.config"

export const basePath = "/assets/pixi-assets/plinkoGame/"

export const path = {
  imagePath: basePath + "images/",
  spriteSheetsPath: basePath + "spriteSheets/",
  fontPath:"/assets/font/",
  localPath: "/assets/images/plinko/"
};

export const config = {
  maxLines: 16,
  originalWidth: 1080,
  originalHeight: 1080,
  topMargin: 580,
  rows: 8,
  pegs: {
    spacing: {
      width: 80,
      height: 80,
    },
    pegsWidth: 24,
    shine: {
      animationSpeed: 1.3,
    },
  },
  ball: {
    path: [0, 1, 0, 1, 0, 1, 0, 1],
    currentRow: 0,
    animationSpeed: 0.8, // 0.9,
    scaleForAnimation: [1.9, 1.7, 1.52, 1.376, 1.26, 1.16, 1.054, 1, 0.93],
    bounceEffect: {
      //                 8    9    10     11     12     13     14    15    16
      scaleFactorScale: [1, 0.99, 0.89, 0.8, 0.79, 0.76, 0.74, 0.72, 0.56],
      scaleFactorX: [1, 0.888, 0.78, 0.73, 0.667, 0.65, 0.59, 0.542, 0.52],
      scaleFactorY: [1.01, 0.888, 0.796, 0.72, 0.655, 0.6, 0.555, 0.517, 0.48],
    },
  },
  box: {
    boxSpeed: 2,
    height: 65,
    width: 150,
    heightScale: 0, //75
    widthScale: 5.2,
  },
  pinInFirstLine: 3,
  bgAssets: {
    speed: 0.06,
  },
  progress: {
    bar: {
      backgroundColor: '#e55039',
      border: 4,
      borderColor: '#FFFFFF',
      fillColor: '#4cd137',
      height: 30,
      radius: 25,
      width: 550,
    },
    text: {
      visible: true,
      fill: 0xffffff,
      fontSize: 30,
    }
  }
};

export const gameDisplaySettings = {
  size: 1320,
  x: config.originalWidth / 2,
  y: config.originalHeight / 2 - 50,
};
